(() => {
  if (window.growthlabSwipeReady) return;
  window.growthlabSwipeReady = true;
  const selector = '[data-proof-track],[data-case-track],.gl-judgeme-reviews .jdgm-all-reviews__body,.gtr[data-tier-style="swipe"] .gtr-option--1 .gtr-choices';
  let drag, suppressClick;
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = event.target.closest(selector);
    if (!track || track.scrollWidth <= track.clientWidth || event.target.closest('button,input,select,textarea')) return;
    drag = {track, id:event.pointerId, x:event.clientX, y:event.clientY, left:track.scrollLeft, active:false};
    suppressClick = null;
  });
  document.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.active) {
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) { drag = null; return; }
      if (Math.abs(dx) < 6) return;
      drag.active = true;
      drag.track.classList.add('is-dragging');
      drag.track.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    drag.track.scrollLeft = drag.left - dx;
  }, {passive:false});
  const finish = event => {
    if (!drag || event.pointerId !== drag.id) return;
    if (drag.active) {
      drag.track.classList.remove('is-dragging');
      suppressClick = drag.track;
      if (drag.track.hasPointerCapture(drag.id)) drag.track.releasePointerCapture(drag.id);
      setTimeout(() => { suppressClick = null; }, 0);
    }
    drag = null;
  };
  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);
  document.addEventListener('dragstart', event => { if (event.target.closest(selector)) event.preventDefault(); });
  document.addEventListener('click', event => {
    if (suppressClick?.contains(event.target)) { event.preventDefault(); event.stopPropagation(); }
  }, true);
})();
